var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"font-weight-bolder mb-2"},[_vm._v(" ใส่คำตอบ [ระบบจะทำการเช็คคำตอบที่ถูกต้องให้] ")]),(!_vm.textareaValue)?_c('p',{staticClass:"no-answer"},[_vm._v(" ยังไม่กำหนดคำตอบของคำถาม ")]):_vm._e(),_c('div',{staticClass:"mt-2"},[_vm._v(" "+_vm._s(_vm.textareaValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }